/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {retryFlow} from '../api'

export const useMutationRetryFlow = createReactQueryMutationHook('retryFlow', retryFlow)
